var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogosTailwindcssIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 38,
    viewBox: "0 0 70 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9999 0C25.6671 0 19.8339 4.13745 17.5008 12.4121C21.0006 8.27467 25.0836 6.72315 29.7501 7.75758C32.4125 8.34764 34.3155 10.0604 36.4219 11.9559C39.8534 15.0441 43.8246 18.6182 52.4989 18.6182C61.8316 18.6182 67.6648 14.4807 69.9979 6.20606C66.4981 10.3435 62.4151 11.895 57.7486 10.8606C55.0863 10.2705 53.1833 8.55782 51.0768 6.6623C47.6454 3.57406 43.6742 0 34.9999 0ZM17.5008 18.6182C8.16808 18.6182 2.33488 22.7556 0.00177002 31.0303C3.50158 26.8928 7.5846 25.3413 12.2511 26.3758C14.9134 26.9658 16.8164 28.6785 18.9229 30.5741C22.3543 33.6623 26.3255 37.2364 34.9999 37.2364C44.3326 37.2364 50.1658 33.0989 52.4989 24.8242C48.9991 28.9617 44.9161 30.5132 40.2496 29.4788C37.5872 28.8887 35.6842 27.176 33.5778 25.2805C30.1463 22.1922 26.1751 18.6182 17.5008 18.6182Z",
    fill: "url(#paint0_linear_18_280)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_280",
    x1: -1.94272,
    y1: 11.9156,
    x2: 54.6674,
    y2: 48.7297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2298BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ED7B5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 37.3333,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosTailwindcssIcon);
export default __webpack_public_path__ + "static/media/logos_tailwindcss-icon.870f963f8dfb497f56a2efb0a206aeaf.svg";
export { ForwardRef as ReactComponent };